import { render } from "./BookingFailed.vue?vue&type=template&id=ca1b60fc&scoped=true"
import script from "./BookingFailed.vue?vue&type=script&lang=js"
export * from "./BookingFailed.vue?vue&type=script&lang=js"

import "./BookingFailed.vue?vue&type=style&index=0&id=ca1b60fc&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ca1b60fc"],['__file',"src/views/Home/MakeAppointment/BookingFailed.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "ca1b60fc"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('ca1b60fc', __exports__)) {
    console.log('reload')
    api.reload('ca1b60fc', __exports__)
  }
  
  module.hot.accept("./BookingFailed.vue?vue&type=template&id=ca1b60fc&scoped=true", () => {
    console.log('re-render')
    api.rerender('ca1b60fc', render)
  })

}


export default __exports__